import { Component, OnInit} from '@angular/core';
import { BaseComponent } from './base.component';

@Component({
  selector: 'app-list-base',
  template: ''
})
export class ListBaseComponent extends BaseComponent implements OnInit {

  //use this class only for list operations

  public constructor() {
    super();
  }

}